import { render, staticRenderFns } from "./SystemCustomNotificationUserListItem.vue?vue&type=template&id=1db54139&scoped=true"
import script from "./SystemCustomNotificationUserListItem.vue?vue&type=script&lang=js"
export * from "./SystemCustomNotificationUserListItem.vue?vue&type=script&lang=js"
import style0 from "./SystemCustomNotificationUserListItem.vue?vue&type=style&index=0&id=1db54139&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db54139",
  null
  
)

export default component.exports